var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"fa fa-external-link",attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.externalLink)?_c('span',{staticClass:"sr-only"},[_vm._v("(External link)")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("(Opens in a new tab)")])])
}
var staticRenderFns = []

export { render, staticRenderFns }